var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConverters(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(7.000000, 4.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 11.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,0 L18,4.03150102 C18,5.6734431 16.6568542,7.5 15,7.5 L2,7.5",
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(2.000000, 7.500000) scale(-1, 1) translate(-2.000000, -7.500000) translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-19",
    points: "6.70796751e-13 -4.07229805e-13 3.56234741 3.5 6.70796751e-13 7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(8.500000, 6.500000) scale(-1, -1) translate(-8.500000, -6.500000) "
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 0.034058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,0.465942383 L17,4.4974434 C17,6.13938548 15.6568542,7.96594238 14,7.96594238 L1,7.96594238",
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(2.000000, 7.965942) scale(-1, 1) translate(-2.000000, -7.965942) translate(0.000000, 4.465942)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-19",
    points: "6.70796751e-13 -4.07229805e-13 3.5640564 3.5 6.70796751e-13 7"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConverters);
export default __webpack_public_path__ + "static/media/converters.bc8bdb84df0e0eddb70e046084db4568.svg";
export { ForwardRef as ReactComponent };